"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithUnifiedPunches = exports.useDaysWithPunches = void 0;
const luxon_1 = require("luxon");
function useDaysWithPunches({ punches }) {
    var _a;
    return (_a = punches === null || punches === void 0 ? void 0 : punches.punchesTimeSegments) === null || _a === void 0 ? void 0 : _a.filter((punch) => !!punch.startDateTime && !!punch.endDateTime).map((punch) => luxon_1.DateTime.fromISO(punch.startDateTime)).filter((dateTime) => !!dateTime);
}
exports.useDaysWithPunches = useDaysWithPunches;
const useDaysWithUnifiedPunches = ({ punchWithTimespans }) => {
    const daysWithPunches = new Set();
    const filteredPunchWithTimespans = punchWithTimespans.filter((punchWithTimespan) => {
        var _a, _b;
        return !!((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime) &&
            !!((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime);
    });
    filteredPunchWithTimespans.forEach((punchWithTimespan) => {
        var _a, _b;
        if ((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime) {
            const punchDate = luxon_1.DateTime.fromISO(punchWithTimespan.startSpan.punchDateTime.timestamp);
            daysWithPunches.add(punchDate);
        }
        if ((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime) {
            const punchDate = luxon_1.DateTime.fromISO(punchWithTimespan.endSpan.punchDateTime.timestamp);
            daysWithPunches.add(punchDate);
        }
    });
    return Array.from(daysWithPunches);
};
exports.useDaysWithUnifiedPunches = useDaysWithUnifiedPunches;
